import { useRouteModule } from '@/app/moduleCache'
import { loadMarketingPage } from '@/app/routePreload'

/**
 * The spec-driven marketing route. Reads the MarketingPage module from the
 * route cache (its loader fetched it), so the switch from another page never
 * passes through a blank Suspense fallback.
 */
export function SpecRoute() {
  const { MarketingPage } = useRouteModule('route:marketing', loadMarketingPage)
  return <MarketingPage />
}
